import { ComponentPropsWithRef } from "react";
import React from "react";

export const Box = React.forwardRef<
  HTMLDivElement,
  ComponentPropsWithRef<"div">
>(({ className, ...props }, ref) => {
  return <div ref={ref} className={className} {...props} />;
});
